(() => {
  'use strict';
  function mount(rail, label, signal) {
    if (rail.dataset.merchandisingRail) return;
    rail.dataset.merchandisingRail = '';
    rail.tabIndex = 0;
    rail.setAttribute('role', 'group');
    rail.setAttribute('aria-label', label + '. Swipe or use arrow keys to explore.');
    const footer = document.createElement('div'), restart = document.createElement('button');
    footer.className = 'merchandising-rail-footer';
    restart.className = 'merchandising-restart';
    restart.type = 'button';
    restart.textContent = 'Back to start';
    restart.setAttribute('aria-label', 'Back to start of ' + label);
    restart.hidden = true;
    footer.append(restart); rail.after(footer);
    const behavior = () => matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
    const cards = () => [...rail.querySelectorAll('a[href],button:not(:disabled)')];
    const focusCard = card => { if (!card) return; card.focus({preventScroll: true}); rail.scrollTo({left: rail.scrollLeft + card.getBoundingClientRect().left - rail.getBoundingClientRect().left, behavior: behavior()}); };
    const update = () => { restart.hidden = !(rail.scrollWidth > rail.clientWidth + 4 && rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 8); };
    restart.addEventListener('click', () => { rail.scrollTo({left: 0, behavior: behavior()}); cards()[0]?.focus({preventScroll: true}); }, {signal});
    rail.addEventListener('scroll', update, {passive: true, signal});
    rail.addEventListener('keydown', event => {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      const items = cards(); if (!items.length) return;
      const at = items.indexOf(document.activeElement);
      const index = event.key === 'Home' ? 0 : event.key === 'End' ? items.length - 1 : (at < 0 ? (event.key === 'ArrowRight' ? 0 : items.length - 1) : (at + (event.key === 'ArrowRight' ? 1 : -1) + items.length) % items.length);
      event.preventDefault(); focusCard(items[index]);
    }, {signal});
    let drag = null, suppressClick = false;
    rail.addEventListener('pointerdown', event => {
      if (event.pointerType === 'touch' || event.button !== 0) return;
      drag = {id: event.pointerId, x: event.clientX, y: event.clientY, scroll: rail.scrollLeft, moved: false};
      suppressClick = false;
    }, {signal});
    rail.addEventListener('pointermove', event => {
      if (!drag || event.pointerId !== drag.id) return;
      if (!(event.buttons & 1)) { drag = null; rail.classList.remove('is-dragging'); return; }
      const dx = event.clientX - drag.x, dy = event.clientY - drag.y;
      if (!drag.moved && Math.abs(dx) > 7 && Math.abs(dx) > Math.abs(dy)) {
        drag.moved = true; rail.setPointerCapture(event.pointerId); rail.classList.add('is-dragging');
      }
      if (drag.moved) { event.preventDefault(); rail.scrollLeft = drag.scroll - dx; }
    }, {signal});
    const end = event => { if (!drag || event.pointerId !== drag.id) return; suppressClick = drag.moved; drag = null; rail.classList.remove('is-dragging'); };
    rail.addEventListener('pointerup', end, {signal});
    rail.addEventListener('pointercancel', end, {signal});
    rail.addEventListener('lostpointercapture', end, {signal});
    rail.addEventListener('click', event => { if (suppressClick) { event.preventDefault(); event.stopImmediatePropagation(); suppressClick = false; } }, {capture: true, signal});
    rail.addEventListener('dragstart', event => event.preventDefault(), {signal});
    const resize = new ResizeObserver(update); resize.observe(rail);
    signal?.addEventListener('abort', () => resize.disconnect(), {once: true});
    update();
  }
  window.HobbytronMerchandising = {mount};
})();
